import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "px-4 py-3 border-b border-gray-100 hover:bg-gray-50 transition-colors" }
const _hoisted_2 = { class: "flex items-start justify-between gap-3" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "text-xs text-gray-500 mb-2" }
const _hoisted_7 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_8 = { class: "w-full bg-gray-200 rounded-full h-1.5" }
const _hoisted_9 = { class: "flex items-center justify-between text-xs" }
const _hoisted_10 = { class: "text-gray-600" }
const _hoisted_11 = {
  key: 0,
  class: "text-green-600 ml-1"
}
const _hoisted_12 = {
  key: 1,
  class: "text-yellow-600 ml-1"
}
const _hoisted_13 = {
  key: 2,
  class: "text-red-600 ml-1"
}
const _hoisted_14 = { class: "text-gray-500" }
const _hoisted_15 = {
  key: 0,
  class: "text-xs text-yellow-600 mt-1"
}
const _hoisted_16 = {
  key: 1,
  class: "space-y-1"
}
const _hoisted_17 = {
  key: 0,
  class: "mt-2 text-xs text-red-600"
}
const _hoisted_18 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("svg", {
            class: "w-4 h-4 text-gray-400 flex-shrink-0",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            })
          ], -1)),
          _createElementVNode("p", {
            class: "text-xs font-medium text-gray-900 truncate",
            title: _ctx.upload.fileName
          }, _toDisplayString(_ctx.upload.fileName), 9, _hoisted_5)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getImportTypeLabel(_ctx.upload.importType)), 1),
        (_ctx.status)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass(["h-1.5 rounded-full transition-all duration-300", _ctx.getProgressBarColor(_ctx.status.status)]),
                  style: _normalizeStyle({ width: `${_ctx.status.progressPercentage}%` })
                }, null, 6)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.status.processedRecords) + " / " + _toDisplayString(_ctx.status.totalRecords) + " ", 1),
                  (
                  _ctx.status.status === 'completed' && _ctx.status.failedRecords === 0
                )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "✓"))
                    : _createCommentVNode("", true),
                  (_ctx.status.status === 'completed' && _ctx.status.failedRecords > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "⚠"))
                    : _createCommentVNode("", true),
                  (_ctx.status.status === 'failed')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "✗"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.status.progressPercentage.toFixed(0)) + "%", 1)
              ]),
              (_ctx.status.failedRecords > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.status.failedRecords) + " record(s) failed ", 1))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "w-full bg-gray-200 rounded-full h-1.5" }, [
                _createElementVNode("div", { class: "h-1.5 rounded-full bg-blue-500 animate-pulse w-1/4" })
              ], -1),
              _createElementVNode("p", { class: "text-xs text-gray-500" }, "Starting upload...", -1)
            ]))]))
      ]),
      (_ctx.status?.status === 'completed' || _ctx.status?.status === 'failed')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleRemove && _ctx.handleRemove(...args))),
            class: "text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M6 18L18 6M6 6l12 12"
              })
            ], -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.status?.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.status.errorMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.status?.errorCsvUrl)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.status.errorCsvUrl,
          target: "_blank",
          class: "mt-2 text-xs text-primary-purple hover:underline inline-flex items-center gap-1"
        }, " Download error report ↓ ", 8, _hoisted_18))
      : _createCommentVNode("", true)
  ]))
}